import React from "react";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";

const adSizes = [
  "728×90",
  "300×250",
  "320×50",
  "336×280",
  "300×600",
];

const Step1AdDetails = ({
  sectionTitleSx,
  sectionSubTextSx,
  primaryButtonSx,
  templateName,
  setTemplateName,
  campaignName,
  setCampaignName,
  agencyName,
  setAgencyName,
  clientName,
  setClientName,
  adType,
  setAdType,
  dimension,
  setDimension,
  landingPage,
  setLandingPage,
  handleImageUpload,
  uploadedImages,
  handleGenerateAd,
  loading,
}) => {
  return (
    <>
      <Typography variant="h5" sx={sectionTitleSx}>
        Ad Details
      </Typography>

      <Typography sx={sectionSubTextSx}>
        Fill in details and upload creatives (Max 7)
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Template Name"
            fullWidth
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Campaign Name"
            fullWidth
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Agency Name"
            fullWidth
            value={agencyName}
            onChange={(e) => setAgencyName(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Client Name"
            fullWidth
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            label="Ad Type"
            fullWidth
            value={adType}
            onChange={(e) => setAdType(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <InputLabel>Ad Size</InputLabel>
            <Select
              value={dimension}
              label="Ad Size"
              onChange={(e) => setDimension(e.target.value)}
            >
              {adSizes.map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Landing Page"
            fullWidth
            value={landingPage}
            onChange={(e) => setLandingPage(e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{ height: "56px" }}
          >
            Upload Creative(s)
            <input
              hidden
              multiple
              type="file"
              accept=".psd,image/png,image/jpeg,video/mp4,video/webm,video/quicktime"
              onChange={handleImageUpload}
            />
          </Button>
        </Grid>
      </Grid>

      {uploadedImages.length > 0 && (
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 2 }}>
          {uploadedImages.map((file, index) => {
            const isVideo =
              file.type.includes("mp4") ||
              file.type.includes("webm") ||
              file.type.includes("quicktime");

            return (
              <Box
                key={index}
                sx={{
                  width: 160,
                  height: 160,
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  overflow: "hidden",
                  background: "#fafafa",
                }}
              >
                {file.name.endsWith(".psd") ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      fontWeight: 600,
                    }}
                  >
                    PSD
                  </Box>
                ) : isVideo ? (
                  <video
                    src={URL.createObjectURL(file)}
                    controls
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <img
                    src={URL.createObjectURL(file)}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      )}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Button
          variant="contained"
          onClick={handleGenerateAd}
          sx={{ ...primaryButtonSx, width: 220 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Generate Creatives"
          )}
        </Button>
      </Box>
    </>
  );
};

export default Step1AdDetails;
